import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Editing is making changes to a resource that already exists in the system.
Updating and editing should use the same behavior as when the resource is created. This should only vary in situations where the number of editable fields is significantly smaller or larger than during creation, or the context of current settings is required.`}</p>
    </PageDescription>
    <h4>{`Status:`}</h4>
    <p><a parentName="p" {...{
        "href": "/experimental/overview/"
      }}>{`Experimental`}</a></p>
    <h4>{`Maintainers:`}</h4>
    <p><a parentName="p" {...{
        "href": "https://github.com/vikkipaterson"
      }}>{`Vikki Paterson`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/chloepoulterdesign"
      }}>{`Chloe Poulter`}</a></p>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Low-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">High-impact edit</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Optional extras</AnchorLink>
    </AnchorLinks>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "60.670731707317074%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAB4UlEQVQoz51Tu24aQRT191npgkTBK/kCkKKI8GYXdpd3FrAERUKV2iloo0iJZCJB5SIRCAko6ICQx9rYvI73XIdghIsoI53dOztnztw59+7JdrvFbjDebDZ/wfljeMh5yOM44WMymSAUCkHTNEQiEYn/BeFwGMFgEIqiYDqd7gUHgwEcDgeSyaQIJhIJQTweF8RisQPw247DORM5EByNRnC73dB1HaqqCqLRKJrNJnq9HrrdLvr9voBxtVoVoVQqJdnlcjnMZrO94HA4hMfjQbFYhGEYyGazQmy320JarVZYr9fi03K5RKPREDEKkV8qlQ4zpKDX64VpmiJWKBSQTqfRarVgWZbg+nqBxeIWP3/9FkHD0IVHPvcdCfLKJNCPTCYj/nQ6HcnOsq6wsL7j9mqK9c0PNN6+gWLbQh753HfkocvlktPoH7Oj4Pn5e7n2l9YFPl/O8PEr8OnbFq/PbMFk3OZpj3u4KwoX6A0FWaBAIACfz4fnz7x46n+H05cXePLiA0KKCUOzD9Z04efz+eOiOJ1OEWFmbB+CZF6JMFJRZNSgjVdQlXsOs2MLsTAHVx6Px/D7/ajVaiiXy6hUKgLGe1RhVs5g2u/yn3WCBanX65jP53tBtgPNZ0v8L3a/3h14bOyHSP5tXQAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Contextual image of an edit modal",
        "title": "Contextual image of an edit modal",
        "src": "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/3cbba/Contextual.png",
        "srcSet": ["/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/7fc1e/Contextual.png 288w", "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/a5df1/Contextual.png 576w", "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/3cbba/Contextual.png 1152w", "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/0b124/Contextual.png 1728w", "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/4ea69/Contextual.png 2304w", "/static/7622ab03a17a391bdd2c9cd6ec8bfa2c/0cbe4/Contextual.png 2624w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Example of an edit modal in context</Caption>
    <h2>{`Low-impact edit`}</h2>
    <p>{`For low-impact edits, allow editing with no warning. This approach is typically used when editing doesn’t have a wider impact.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAyklEQVQoz82T2wqDMBBE/f+fFPEGSvB+IYluOwsb1ob60PahgWHW1RwniSb0HOd50i8GOInA4N8KIwD3faeu62gcR1qW5VbrukY6jiMGDsPAwDtN00R937PatqWmadidc1cgHsiyjOq6pqIoWFVVUZ7n7GVZhhqO+/A0Tbm21l6B27bxkiWBpEUNx/VrT9fe+xiICfM8h6VBugehlp4xhhPDoyVroCQRIFzvoQZiD98mRHyZoA9AegLXL5H70SmjgdifKnyHf/+nPABBnadZiFvl0AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of an edit button in a table",
            "title": "Example of an edit button in a table",
            "src": "/static/231838378a246b253cf10e82938196ef/3cbba/02.png",
            "srcSet": ["/static/231838378a246b253cf10e82938196ef/7fc1e/02.png 288w", "/static/231838378a246b253cf10e82938196ef/a5df1/02.png 576w", "/static/231838378a246b253cf10e82938196ef/3cbba/02.png 1152w", "/static/231838378a246b253cf10e82938196ef/0b124/02.png 1728w", "/static/231838378a246b253cf10e82938196ef/4ea69/02.png 2304w", "/static/231838378a246b253cf10e82938196ef/0cbe4/02.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an edit button in a table</Caption>
      </Column>
    </Row>
    <h3>{`Modal`}</h3>
    <p>{`If an object was created in a modal, its editable fields can be made available in a modal. A modal can also be used where a small subset of fields are editable.
If enough fields are editable to require scrolling, use a side-panel or full-page edit dialog instead.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA/ElEQVQoz52T3WqDMBiGvZ8d7WhXsAuQUnq4i5gUdgG7SisdO0hr8CeaxESpeZcoLbXV0izw8IG+PMn3aQLcLGPMwDNrLhcsyVzt+/7ybI45abC0Y1EUSNMUeZ5DSnmHt7Cua5RliaZpoJS642nhOVBVFTjnaNsWWusJXsJzdTJ3ylvZv4VOxhgbWnZIOcKFgBDSv2U3eEopsiwbKz1YCFhBYU56zPqckBCCOI6RJAl2uwR7wvFzVNgfFH5TZX8pj5a7rkMURQjDEJv1CqvNB962OV6/gJfPE96/e+jOc4bCzsrNcfg4FiaNBQN1c519cFOWrtPV2wljdJr/A/oWpPSP+QR7AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low consequence edit action in a modal",
            "title": "Example of a low consequence edit action in a modal",
            "src": "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/3cbba/03.png",
            "srcSet": ["/static/02ccdbc4fd71f4556cb885ac8f6bc08b/7fc1e/03.png 288w", "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/a5df1/03.png 576w", "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/3cbba/03.png 1152w", "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/0b124/03.png 1728w", "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/4ea69/03.png 2304w", "/static/02ccdbc4fd71f4556cb885ac8f6bc08b/0cbe4/03.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low consequence edit action in a modal</Caption>
      </Column>
    </Row>
    <h3>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, its editable fields can be made available in a side panel. A side panel can also be used where context in the main view of the screen is useful in the editing flow.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABo0lEQVQoz4VTy2rCUBT0IwUXPn7BtYrv9wvURd0UFbrqutB/6NqNgqigoNWa+ELUxEydUxJNhBqY3BPOPXPPzLlxGYYB82F8uVye4nQ64Xg8WuC3yePia7lcIhQKIZvNIhKJSOxEOByWlflGo4Fms2mh1WphvV7fCIfDIdxuNxKJhBTE43FBLBazYiIajSKdTqPf70NVVSiKgv1+j+12C03TboTj8Rg+nw+5XA6pVArJZFLIWcyYyGQyQprP5zGZTHA+n22SaYVFOBqN4Pf7Ua1WpaBQKDygWCzKgdxjEh4OB4tQ13U7YSAQQK1Wk8JSqfSAcrksOe6hRbvdTqRuNhuJHzqk5EqlIoNhJ06wc8pmh91uF4PBQLzs9XqYzWb2KdNDr9crHdBDeucEyZij/Pl8LgSUzWFwtUk2h0JpZrET7Jw5HrpYLKRY5728NqbpxqOHHo9HpHGSnLATnDRz3EPf7I8B43JHOJ1OEQwG5ZLW63W5uP+h3e7grfOKl/cvpD6A8ucZq90dIf0wvXgGXhFFUfFz/bsWqy1mqobvNT38G8ovNYADZnUA0nYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a low-impact edit action in a side panel",
            "title": "Example of a low-impact edit action in a side panel",
            "src": "/static/532b25ae141057a8f9b664b0ddd61b23/3cbba/LowSidepanel.png",
            "srcSet": ["/static/532b25ae141057a8f9b664b0ddd61b23/7fc1e/LowSidepanel.png 288w", "/static/532b25ae141057a8f9b664b0ddd61b23/a5df1/LowSidepanel.png 576w", "/static/532b25ae141057a8f9b664b0ddd61b23/3cbba/LowSidepanel.png 1152w", "/static/532b25ae141057a8f9b664b0ddd61b23/0b124/LowSidepanel.png 1728w", "/static/532b25ae141057a8f9b664b0ddd61b23/4ea69/LowSidepanel.png 2304w", "/static/532b25ae141057a8f9b664b0ddd61b23/0cbe4/LowSidepanel.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a low impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <h3>{`Full page`}</h3>
    <p>{`When an object is created in a full-page flow and the majority of fields become editable, a full-page edit flow should be used. This is made possible by including a configuration/properties view.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABoklEQVQoz5WSzW+CQBDF/f+PvTRpQvVgVExqFJN6MKY3vxqVoh5NVWhsUREQP0DhdWcNa/WineTnLGb27cy+TYCF7/vo9XqcdvsdzWbzLlqtFur1OtvTxm63Iykk6Gez2UApl6EoCvL5PAqFAkqlEorF4k0qlQpqtRpc1z0LHsMQtutx4pPujdFohH6/z9dRFJ0Eg+CAz/EEs9k3LMvCarXCer3mnVPe7/c4HA6sLriABBqNBqrVKkLW1LnD45G3vN1u+ZqK/xt0oBAkU4bDIUfTNHQ6HXS7XaiqyiGzKA8GAwGNSagfGjSWaQohSGNlsjnkcllIkoRkMolUKsXz9Tomk8lCltmetIQXOQ3bdk6CdA/sMrDZ+rAdT5x0K0zzB1P9C2OmY5DBUYhIjMxMGU+mmDB0XYdhGJjP54LYqJgl+5bZNI9Pz3h4dZB8WyM8BueRA3ahOhNZLBbcHBJZLpdciDL953kev5oYESFbBw7XEILkkGmaXICK42dDrtPTIUjQcRwB1VC9tXIZzqXL9FRoQwx1ZNu22By/yb8115AGxS9pWHRES83C0QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a properties view in reading (top) and editing (bottom) views",
            "title": "Example of a properties view in reading (top) and editing (bottom) views",
            "src": "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/3cbba/05.png",
            "srcSet": ["/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/7fc1e/05.png 288w", "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/a5df1/05.png 576w", "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/3cbba/05.png 1152w", "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/0b124/05.png 1728w", "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/4ea69/05.png 2304w", "/static/ffa7d3e2d028ac5c0f3c52a1f43086d2/0cbe4/05.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a properties view in reading (top) and editing (bottom) views
        </Caption>
      </Column>
    </Row>
    <h2>{`High-impact edit`}</h2>
    <p>{`Warn the user of the consequences of editing. This pattern is typically used when editing has a wider impact.
Inform users of the likely consequences of the edit to their system, and inform them that editing cannot be undone. Include a warning stage.`}</p>
    <h3>{`Modal`}</h3>
    <p>{`A high-impact edit action of only a few fields can use a danger modal. A second confirm edit modal should also be inserted before the changes are saved. If desired, the confirmation modal can include a `}<a parentName="p" {...{
        "href": "#summary-of-changes"
      }}>{`summary of changes`}</a>{`.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABmElEQVQoz62Tu0/CUBTG+cscndh00cQEmJ1MjAOKi0QTYxy08QH+LQ5sDiRGI5GHC6EPLG2hT0rh85yLLeCAmHiTL7c999xfv3NPb2oymeC/BrNS/DAej+H7PoIgQBiGGI1Gifg9iiIhXh8OhyIex+IcZvAQQA60221omgbbtuE4TqLBYCAgPLdaLSGt20XvU4dBsi0LfcNESDkJkL9k0YLrumIzO4nFzmPXpmlC13UM+n0YFFd9Dy7t95gxrXkGZFhc0rw8zxNfrlarkCQJD6USpHIZTzd3MK9uIV9eo3N2Ab/eWHTIpfLmn0B2yKNSqaBQKOC0WMRh8QSP+WNYB0dQ9vNQdvfgP7/MgHE5fE4M9cgtO+bZplgM/VOXDcOAqqqiMSpJoYNXaLbIeUTrnBN3ljUmTeb1/fslXWaYLMuQFQWarMClw3d7PTjUycB2EgfLlABrtRpyuRyymQy2slmcb++gnd7ER3oDrbV16NL9FEguf7sIAsjn1mw20Ww0UCd16nUMa+8IWK9vGCnqgsOlwFWv3qp5X5gcjRbfb3gUAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact editing modal and consequent warning modal",
            "title": "Example of a high-impact editing modal and consequent warning modal",
            "src": "/static/42e89cac2f0c8997c0038d36c7b062ea/3cbba/HighModal.png",
            "srcSet": ["/static/42e89cac2f0c8997c0038d36c7b062ea/7fc1e/HighModal.png 288w", "/static/42e89cac2f0c8997c0038d36c7b062ea/a5df1/HighModal.png 576w", "/static/42e89cac2f0c8997c0038d36c7b062ea/3cbba/HighModal.png 1152w", "/static/42e89cac2f0c8997c0038d36c7b062ea/0b124/HighModal.png 1728w", "/static/42e89cac2f0c8997c0038d36c7b062ea/4ea69/HighModal.png 2304w", "/static/42e89cac2f0c8997c0038d36c7b062ea/0cbe4/HighModal.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a high-impact editing modal and consequent warning modal
        </Caption>
      </Column>
    </Row>
    <h3>{`Side-panel`}</h3>
    <p>{`If an object was created in a side panel, or there are too many editable fields for a modal, a slide-over panel can be used.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.746951219512205%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABvElEQVQoz4VS2YoiQRCcjxRfPD7DA8T7PkB8UFlc2R1md/9kf8AXEVFBQdeW8hq11bZiK4rtHtoe2IboLMjKqIzIfJFSwv4ejwcsy/ovTNPE5XLROJ/POto8L/wZhoFoNIp8Po94PI5YLPYpeIf5VquFTqfjoN/vY7fbfRBOJhP4fD5kMhkkEgmk02mkUikPksmkfnQ0GmmC7XaL0+mE4/GI+/3+QTibzRAMBlEsFpHNZjUxSXO5nD4TJCJpqVTCfD7H9Xp1pDPSLodwOp0iFAqh0WjognK57EGlUtE53lksFrjdbg4ZyemtizAcDqPZbOrCarXqQa1W0zneoUWHwwH7/V5L59nTISXX63UUCgUt/RnsjrLZ4WAwwHg81l4Oh0Msl0v3lOlhIBDQHdBDevcMkjFH+avVShdTNodBuCTbQ6E0u/gZ7Jw5Prper529Va3h8W8/bUKpPJF+v18qaVKthlTT9EBNXecUsVS+UZ8LilxH3SElRCIR9Ho9tNtt19I+o9vt4sfbG15//cTvb684tL9AfP0OeXx3OhTKUKF8EMoTHT+DnWPcCiGMzUbsjY0w/6yFqaK0LEGuvz3kAmcQWjRhAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a high-impact edit action in a side panel",
            "title": "Example of a high-impact edit action in a side panel",
            "src": "/static/85c841679479a3eb97c3b6a07a1e007f/3cbba/HighSidepanel.png",
            "srcSet": ["/static/85c841679479a3eb97c3b6a07a1e007f/7fc1e/HighSidepanel.png 288w", "/static/85c841679479a3eb97c3b6a07a1e007f/a5df1/HighSidepanel.png 576w", "/static/85c841679479a3eb97c3b6a07a1e007f/3cbba/HighSidepanel.png 1152w", "/static/85c841679479a3eb97c3b6a07a1e007f/0b124/HighSidepanel.png 1728w", "/static/85c841679479a3eb97c3b6a07a1e007f/4ea69/HighSidepanel.png 2304w", "/static/85c841679479a3eb97c3b6a07a1e007f/0cbe4/HighSidepanel.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a high-impact edit action in a side panel</Caption>
      </Column>
    </Row>
    <p>{`High-impact side panel edits should also warn the user of destructive edits with a warning before changes are saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.624523990860624%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABiklEQVQoz42SSW7CQBBFuSMSC4Y7sGUQ8zyISQqWEiDiJrkEBwAEOHYMeGVs6B//TjDBjhJaeuqSqut3TSEhhIOv45oCl8vlX06nEyzLuoOxPCEXxzAMpFIpUavVkMlkaAdIp9Pypn84HEJRFI/pdIrD4XATXC6XCIfDolAoIJvNIp/P/0oul0OlUsFiscBut5NQyDRNOI5zE1yv14jH4zLDUqmEYrEIipfLZWkTClGUbzabDc7nM2zb9kplKzzB1WolBbvdLur1OhqNRoBmsynFOp0OdF2/Nt0T4wd3JScSCdHv92Vgq9UK0G63pa/X60HTtLusAoLMMBaLCf5erVZlJn6YOX0UfkgwGo0KZsAesnd+2EP6WP5DguwhS7sG+2F29PFTVVVl8NmdrOBuunegh5FIRE6Zk+SE/XDS9FH4eDzCfy4/F3u73SKZTIrxeIzBYCAX189oNPLu19kMk/kcb88TGIMnqMoL7P3+JkjDXUzBveKC/gXf7N1gro7pYr1rsPQPiO+SPwHTSgZdNX+sEgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a warning screen in a side panel before a user saves changes",
            "title": "Example of a warning screen in a side panel before a user saves changes",
            "src": "/static/e10ed7e0c85b8171d24892da50b7b9a5/3cbba/08.png",
            "srcSet": ["/static/e10ed7e0c85b8171d24892da50b7b9a5/7fc1e/08.png 288w", "/static/e10ed7e0c85b8171d24892da50b7b9a5/a5df1/08.png 576w", "/static/e10ed7e0c85b8171d24892da50b7b9a5/3cbba/08.png 1152w", "/static/e10ed7e0c85b8171d24892da50b7b9a5/0b124/08.png 1728w", "/static/e10ed7e0c85b8171d24892da50b7b9a5/4ea69/08.png 2304w", "/static/e10ed7e0c85b8171d24892da50b7b9a5/6c165/08.png 2626w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a warning screen in a side panel before a user saves changes
        </Caption>
      </Column>
    </Row>
    <h3>{`Full page`}</h3>
    <p>{`When an object was created in a full-page flow, or the volume of editable fields is high, use a full-page edit dialog.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABf0lEQVQoz42S6WrCUBCFff8nERKwti5VUKuY/FAqFkUoVKOIUFATk2g0m6f3RK+aQq0DH5O7ndmSgbD9fo9Go4E3QbVaRblcfphCoYBKpYLdbkcpZKRgvdFErVZPLlG81Wqh2Wz+S6fTQa/Xw3a7vQqGUYyVuYFpOZdIjxrFGJx2PB7PgmGE5XIJ13UQBEECD+Wle2YYBobDIeI4vmZ4OOzRbrehaXriGZGesCxN06Dregru8fy928VHv5/uIevPPeWRz+eRzWahKApUVb0Lh1EslaC8PCMnvOM4J8GkJIF3CGC7Hnzff6h3X+MxRoMBMPoUiwniU3/OJfshJsYUxnSK2WyG+Xye9FRimiYsy7rANbNTRTULNYfv4iuCOLqZchhisVhgvV6LwbiJ5yMJ99gjeokcwg5HuFGEUAzyIhgJwdVqBWuzSfrJLGzbTr4JxQj7JNmIu8Q5w6RSGfISI9NLMSnEH9/zvFSGt/BNSjASKcvIFGPJMsDvh39BDdoP5W5zaMCwdyoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a full-page edit view",
            "title": "Example of a full-page edit view",
            "src": "/static/d518693eed81773092c38a82b96dcefc/3cbba/09.png",
            "srcSet": ["/static/d518693eed81773092c38a82b96dcefc/7fc1e/09.png 288w", "/static/d518693eed81773092c38a82b96dcefc/a5df1/09.png 576w", "/static/d518693eed81773092c38a82b96dcefc/3cbba/09.png 1152w", "/static/d518693eed81773092c38a82b96dcefc/0b124/09.png 1728w", "/static/d518693eed81773092c38a82b96dcefc/4ea69/09.png 2304w", "/static/d518693eed81773092c38a82b96dcefc/0cbe4/09.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a full-page edit view</Caption>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "60.670731707317074%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABt0lEQVQoz42TzUsCURTF+ycDCyLFRUhLKfwYZ5zRUWfMbyQXSrlqF7mQWgvRqv6OCL8pKEVP97wayyxo4Ddv5r3zzrv3zp0tyLVcLjdYLBb/ZklkD68t3sbjMWzbRjqdRiwWQzQaXY1/wfV4PI6IPJuWhX6//2U4mUygJXQcHUeUOJFIwDAMRTKZXMObp1lcTLVIFPZvhmmJUNd1tSmVSiGbzaqILRGbprmCc5lMBvt+P3Z9Pui+XTgHIQyGw+8pT6DLqZqmKUMak0KhgEajgWazibNWS1GrVtUhHqbo3VwOg8FgPUJGxQhYSz4zpV6vp9aGoxGeXp7xJtq7h3t1GHXESllw8/lNQ6bIE5kShYy03W7j+uYG3asrPF528Nrp4rZ1DsP6SN0rieu6m4Y5CZuREZrxgHA4DH8ggFAwiLM9Py62d3AaOoSVkY4Q3b8MKfKK7zgO8pKOIxsMGfXCCUyZsz+j88qT/y1lCtgONGPbsE5891rIFKzP0WshaqljNmttM51OUa/XUalUUJWvWCwWFaVSScG5Wq2mxp+Uy2XVCSP5cCtD/jaz2WzFfD5f4/vaX3i/3jtKAtgE+CkDOgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "title": "Example of a modal warning users of the consequences of saving after a full-page edit",
            "src": "/static/9fb03523bacadbcdb7e45a5baafbdfad/3cbba/10.png",
            "srcSet": ["/static/9fb03523bacadbcdb7e45a5baafbdfad/7fc1e/10.png 288w", "/static/9fb03523bacadbcdb7e45a5baafbdfad/a5df1/10.png 576w", "/static/9fb03523bacadbcdb7e45a5baafbdfad/3cbba/10.png 1152w", "/static/9fb03523bacadbcdb7e45a5baafbdfad/0b124/10.png 1728w", "/static/9fb03523bacadbcdb7e45a5baafbdfad/4ea69/10.png 2304w", "/static/9fb03523bacadbcdb7e45a5baafbdfad/0cbe4/10.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Example of a modal warning users of the consequences of saving after a
  full-page edit
        </Caption>
      </Column>
    </Row>
    <h2>{`Optional extras`}</h2>
    <h3>{`Summary of changes`}</h3>
    <p>{`Adding a summary of changes to the warning stage of a high-impact flow can help the user manage and understand all of the changes they have made.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAABGklEQVQoz52Ty2qEQBBF5+eyCiGLQDYGGQjkN/zHQJjxEUUdBd9Ot4rvG6vBLCbKaAqKSzeXw62i+4CFGscRW2rJd1gztG2Luq6F9n3/213XiZ69t9A/wNkQhiEsy8LlckGWZUjTFHmeg3MuejfQ932oqiqgtm3DNE14noeyLFFV1f8Suq4rlFKSRlGEIAhE4t3AJEkEiACkBKM7AtP4t/67QMaYSEL7IlA6dVEU4NM9u163A+eiPc37EvAJwqez6KrEuPJ0FoGkNNa8tziOwcIIfDqzIEQRJ9t3SEXvTFEUSJIE+XjEhyzj8/kVzuMLzIcnOG/vGJpmX0LHcaBpGnTDwLeuozyraE5n1F8nNLqBcRjuA/d8uzXvDy/7nyp11uiQAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a summary of changes in a modal",
            "title": "Example of a summary of changes in a modal",
            "src": "/static/0d08168c01ec658050834436256113e3/3cbba/12.png",
            "srcSet": ["/static/0d08168c01ec658050834436256113e3/7fc1e/12.png 288w", "/static/0d08168c01ec658050834436256113e3/a5df1/12.png 576w", "/static/0d08168c01ec658050834436256113e3/3cbba/12.png 1152w", "/static/0d08168c01ec658050834436256113e3/0b124/12.png 1728w", "/static/0d08168c01ec658050834436256113e3/4ea69/12.png 2304w", "/static/0d08168c01ec658050834436256113e3/0cbe4/12.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a summary of changes in a modal</Caption>
      </Column>
    </Row>
    <h3>{`Non-editable fields`}</h3>
    <p>{`When a small number of fields are not editable, display their set value in a disabled field.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAAs0lEQVQoz8WTyQqEMBBE/f/fk+gtN/XgQdyXLDVUQyToCBMv0/CoBNqiOokZovLeC/H6iWt/qAxf6tqU0pM9JTyOQ3DO3fg5YdywLAu6rhPdtg3rup6673u6IT+iGQ2oAe6ZPNlwmib0fY95nk9CWmttuiGTjOMoaYwxAo3C2SYbDsOAqqrQNA3quha4pzJ9smHbtsjzHGVZQimFoihEtdYy/qtLYUqOHcMz5Pj/f9hvf70P0byyXatWBdcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a single non-editable field",
            "title": "Example of a single non-editable field",
            "src": "/static/45739d9450d6e23fb40a15f9161df323/3cbba/11.png",
            "srcSet": ["/static/45739d9450d6e23fb40a15f9161df323/7fc1e/11.png 288w", "/static/45739d9450d6e23fb40a15f9161df323/a5df1/11.png 576w", "/static/45739d9450d6e23fb40a15f9161df323/3cbba/11.png 1152w", "/static/45739d9450d6e23fb40a15f9161df323/0b124/11.png 1728w", "/static/45739d9450d6e23fb40a15f9161df323/4ea69/11.png 2304w", "/static/45739d9450d6e23fb40a15f9161df323/0cbe4/11.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a single non-editable field</Caption>
      </Column>
    </Row>
    <p>{`Where a majority of variables are not editable, consider using an option that will display only editable fields. In a small number of cases, make individual variables editable in modals.`}</p>
    <h3>{`Success notifications`}</h3>
    <p>{`An optional success notification can be used to confirm that the user’s changes have been saved.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.83231707317073%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsSAAALEgHS3X78AAAA80lEQVQoz7WSW0+DQBCF+/9/kz4psaa2IMrNlABF5KGlCaVGuex+QoSGKG0x6klOJjtncmYmOxP+GJP+Q0p5iGPYrx00HGP6KXZBHp/wa9djEFIgaGvliQmbpGgFL4u4XM+YxwbTlcZtqHETqCjeHLd4wXz12Ba70yv3Dd0sREl1rvw7LuxrlHDBNL6vqeMUIUbusynTw9rnJ9xHmHnAQ+aySCz03RLzzcd6D3gqn7HKFUljKM8YdkKwjzFqAyN1UTc26tpmFj+iJQ7LIsLJQ7bliJU7oRIVRVlQ1rFq2XxGl29YCfGzs/mGgfRQ7f8f9m/xAYbGrL+24cyAAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Example of a successful editing toast notification",
            "title": "Example of a successful editing toast notification",
            "src": "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/3cbba/13.png",
            "srcSet": ["/static/cff9abb42ee22ed94eb8a20bb1ac9c40/7fc1e/13.png 288w", "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/a5df1/13.png 576w", "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/3cbba/13.png 1152w", "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/0b124/13.png 1728w", "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/4ea69/13.png 2304w", "/static/cff9abb42ee22ed94eb8a20bb1ac9c40/0cbe4/13.png 2624w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a successful editing toast notification</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      